import styled from 'styled-components';

export const BaseWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const FallbackWrapper = styled.div`
  display: flex;
  height: 100%;
`;
